import React, { useState } from 'react';
import { Button } from '@mui/material';
import { PersonAddAlt1 } from '@mui/icons-material';
import InviteDialog from './InviteDialog';

/** Drop-in "Invite a dive buddy" button that owns its dialog. Render only for signed-in users. */
const InviteButton: React.FC<{ variant?: 'contained' | 'outlined' | 'text' }> = ({ variant = 'outlined' }) => {
  const [open, setOpen] = useState(false);
  return (
    <>
      <Button variant={variant} size="small" startIcon={<PersonAddAlt1 />} onClick={() => setOpen(true)}>
        Invite a buddy
      </Button>
      {open && <InviteDialog open onClose={() => setOpen(false)} />}
    </>
  );
};

export default InviteButton;
